export interface IComentario {
    IdComentario?: number;
    IdComentarioPadre?: number;
    // Tabla: string;
    // IdTabla: number;
    IdEmisor?: number;
    Emisor?: string;
    Fecha?: Date;
    Contenido: string;
    Valoracion?: number;
    Metadata?: any;

    Nivel?: number;
    // Reply?: string;
    // children?: ComentarioModel[];
}

export class ComentarioModel {
    IdComentario?: number;
    IdComentarioPadre?: number;
    // Tabla: string;
    // IdTabla: number;
    IdEmisor?: number;
    Emisor?: string;
    Fecha?: Date;
    Contenido: string;
    Valoracion?: number;
    Metadata?: any;

    Nivel?= 1;
    Reply?: string;
    children?: ComentarioModel[] = [];
    flagReply: boolean;

    constructor(data?: IComentario) {
        if (data) {
            this.IdComentario = data.IdComentario;
            this.IdComentarioPadre = data.IdComentarioPadre;
            // this.Tabla = data.Tabla;
            // this.IdTabla = data.IdTabla;
            this.IdEmisor = data.IdEmisor;
            this.Emisor = data.Emisor;
            this.Fecha = data.Fecha && new Date(data.Fecha);
            this.Contenido = data.Contenido;
            this.Valoracion = data.Valoracion;
            this.Metadata = typeof data.Metadata === 'string' ? JSON.parse(data.Metadata) : data.Metadata;

            this.Nivel = data.Nivel || 1;
            // this.Reply = data.Reply;
            // this.children = data.childrens || [];
        }
    }
}
